import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModConnect: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M11.2578 2.04599C11.6658 1.63799 11.6658 0.975986 11.2578 0.566986C10.8498 0.158986 10.1878 0.158986 9.7788 0.566986L6.8218 3.52499L8.3008 5.00299L11.2578 2.04599Z' />
			<path d='M2.374 10.2276L0 12.6016L3.137 15.7386L5.345 13.5306C8.149 15.1746 11.81 14.8016 14.215 12.3966L3.865 2.04559C1.652 4.25859 1.16 7.53459 2.374 10.2276Z' />
			<path d='M14.2144 5.00299C14.6234 4.59499 15.2854 4.59499 15.6934 5.00299C16.1024 5.41199 16.1024 6.07299 15.6934 6.48199L12.7364 9.43999L11.2574 7.96099L14.2144 5.00299Z' />
		</Svg>
	);
};

export { ModConnect };
